import moment from 'moment';
import React, {PropTypes} from 'react';

export default function FormattedDate({date, format}) {
  return <span>{moment(date).format(format || 'YYYY-MM-DD hh:mm:ss A')}</span>;
}

FormattedDate.propTypes = {
  date: PropTypes.string.isRequired,
  format: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/features/shared/components/FormattedDate.js